import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CardPricingTemplateDto } from 'app/core/models/pricing-templates';
import { MinorUnitsToCurrencyPipe } from 'app/core/pipes/minor-units-to-currency.pipe';
import { TemplateStatusChipConfigPipe } from 'app/core/pipes/template-status-chip-config.pipe';
import { TransactionFeeTypePipe } from 'app/core/pipes/transaction-fee-type-pipe';
import { TilledChipComponent } from 'app/shared/tilled-chip/tilled-chip.component';
import {
  TilledHeadingH4Component,
  TilledLabelL1Component,
  TilledParagraphP3Component,
  TilledParagraphP4Component,
} from 'app/shared/tilled-text';
import { EditablePricingTemplateNicknameDialogComponent } from '../editable-pricing-template-nickname-dialog/editable-pricing-template-nickname-dialog.component';
import { GenericPricingTemplateListItem } from '../generic-pricing-template-list-item';

@Component({
  selector: 'card-present-pricing-template-list-item',
  templateUrl: './card-present-pricing-template-list-item.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TilledHeadingH4Component,
    TilledChipComponent,
    TilledParagraphP4Component,
    TilledParagraphP3Component,
    TilledLabelL1Component,
    MinorUnitsToCurrencyPipe,
    TransactionFeeTypePipe,
    TemplateStatusChipConfigPipe,
    CommonModule,
    MatIcon,
  ],
  providers: [],
})
export class CardPresentPricingTemplateListItemComponent extends GenericPricingTemplateListItem implements OnInit {
  @Input() detailView: boolean = false;
  @Input() canClick: boolean = true;
  @Input() canEdit: boolean = false;
  @Input() template: CardPricingTemplateDto;
  @Output() cardClick: EventEmitter<number> = new EventEmitter<number>();

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnInit() {}

  onButtonClick() {}

  openEditNickNameDialog(): void {
    const dialogRef = this.dialog.open(EditablePricingTemplateNicknameDialogComponent, {
      data: {
        nickname: this.template.nickname,
        pricingTemplateId: this.template.id,
        accountId: this.template.accountId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.template.nickname = result;
      }
    });
  }
}
